module.exports = __webpack_public_path__ + "static/media/pizza.3e7d57a5.svg";